module.exports = __webpack_public_path__ + "img/ohm-intro.5b28c017.png";